export class SectionContent { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/models/sectionContent.model.ts